if (!customElements.get('custom-cursor')) {
    class CustomCursor extends HTMLElement {
        constructor() {
            super();

            this.elCursor = this.querySelector('img');
            this.parent = this.parentNode;

            if (!this.elCursor || !this.parent) return;

            this.targetX = 0;
            this.targetY = 0;
            this.current = {
                x: 0,
                y: 0
            };
            this.isFollowing = false;
            this.rafId = null;
            this.tick = null;

            this.canHover = window.matchMedia(
              "(hover: hover) and (pointer: fine)",
            ).matches;

            if (!this.canHover) return;

            this.onPointerMove = (event) => {
                if (!this.classList.contains('visible')) return;

                const rect = this.parent.getBoundingClientRect();
                this.targetX = event.clientX - rect.left;
                this.targetY = event.clientY - rect.top;
            };

            this.onEnter = (event) => {
                this.classList.add('visible');
                this.seedPosition(event);
                this.applyTransform();
                this.startFollowLoop();
            };

            this.onLeave = (event) => {
                this.classList.remove('visible');
                this.stopFollowLoop();
            }

            this.parent.addEventListener('mouseenter', this.onEnter);
            this.parent.addEventListener('mouseleave', this.onLeave);
            this.parent.addEventListener('pointermove', this.onPointerMove);
        }
        disconnectedCallback() {
            this.stopFollowLoop();

            if (!this.parent) return;

            this.parent.removeEventListener('mouseenter', this.onEnter);
            this.parent.removeEventListener('mouseleave', this.onLeave);
            this.parent.removeEventListener('pointermove', this.onPointerMove);
        }

        seedPosition(event) {
            const x = event?.clientX ?? this.targetX;
            const y = event?.clientY ?? this.targetY;

            this.current.x = this.targetX = x;
            this.current.y = this.targetY = y;
        }

        startFollowLoop() {
            if (this.isFollowing) return;
            this.isFollowing = true;

            this.tick = () => {
                if (!this.classList.contains('visible')) return;

                const ease = 0.15;
                this.current.x += (this.targetX - this.current.x) * ease;
                this.current.y += (this.targetY - this.current.y) * ease;

                this.applyTransform();

                this.rafId = requestAnimationFrame(this.tick);
            };

            this.rafId = requestAnimationFrame(this.tick);
        }

        stopFollowLoop() {
            if (!this.isFollowing) return;

            cancelAnimationFrame(this.rafId);
            this.rafId = null;
            this.isFollowing = false;
        }

        applyTransform() {
            if (!this.elCursor) return;

            this.elCursor.style.transform = `translate(${this.current.x}px, ${this.current.y}px)`;
        }
    }

    customElements.define('custom-cursor', CustomCursor);
}